import React, { useState } from "react";
import { useSelector } from "react-redux";

import {
  EXPENSE_PENDING_SUPERVISOR,
  CHECK_SUPERVISOR_EXPENSE,
} from "../../api/allApi_List";
import DialogBox from "../../components/UI/DialogBox";
import MainPending from "../../components/expense/pending/MainPending";
import spin from "../../assets/icons/spin.png";
import useCheckData from "../../CustomHooks/useAxios/useCheckData";
import { handleErrMessage } from "../../functions/handleErrMessage";
import MainPageLayout from "../../layout/MainPageLayout";
import useFetchData from "../../CustomHooks/useAxios/useFetchData";

const SupervisorPendingPage = () => {
  const { isLoaded } = useFetchData(
    EXPENSE_PENDING_SUPERVISOR,
    "pendingExpense"
  );
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  const {
    confirmDialogBox,
    setConfirmDialogBox,
    setBodyData,
    isActionSucceed,
    setIsActionSucceed,
    buttonStatus,
    setButtonStatus,
    handleCheck,
    checkResponseData,
    checkedErr,
    setCheckedErr,
    checkLoading,
    bodyData,
  } = useCheckData("patch", CHECK_SUPERVISOR_EXPENSE);

  // handle confirm dialog box on single expense checked
  const handleConfirmDialogBox = (id, status) => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
    setConfirmDialogBox(true);
    setBodyData((prev) => {
      return { ids: [id], statuses: [status] };
    });
    setButtonStatus(status);
  };

  // handle confirm dialog box on multiple expense checked
  const handleMultiCheckConfirmDialog = (ids, statuses) => {
    setConfirmDialogBox(true);
    setBodyData((prev) => {
      return { ids: ids, statuses: statuses };
    });
    setButtonStatus("multiple");
  };
  return (
    <MainPageLayout
      headerConfig={{ title: "Supervisor Pending" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <MainPending
          pageTitle="Supervisor Pending Expenses"
          viewDialogDetails={viewDialogDetails}
          setViewDialogDetails={setViewDialogDetails}
          handleConfirmDialogBox={handleConfirmDialogBox}
          confirmDialogBox={confirmDialogBox}
          setConfirmDialogBox={setConfirmDialogBox}
          isActionSucceed={isActionSucceed}
          setIsActionSucceed={setIsActionSucceed}
          buttonStatus={buttonStatus}
          handleCheck={handleCheck}
          checkResponseData={checkResponseData}
          handleMultiCheckConfirmDialog={handleMultiCheckConfirmDialog}
          checkLoading={checkLoading}
          bodyData={bodyData}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {checkedErr && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(checkedErr)}
          closeAction={() => setCheckedErr(false)}
        />
      )}
    </MainPageLayout>
  );
};

export default SupervisorPendingPage;
